import styled from 'styled-components';
import { maxWidth } from 'config/constants';

export const StyledAddServiceCase = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${(props): string => props.theme.kcc.colors.GRAY_50};

  .add-service-case__header {
    background-color: var(--primary);
    padding: 40px ${(props): string => props.theme.kcc.spacing.XXL};

    ${maxWidth.l} {
      padding: 40px 36px;
    }

    ${maxWidth.m} {
      padding: 24px 23px 40px 23px;
    }
  }

  .add-service-case__title {
    font-family: ${(props): string => props.theme.kcc.typography.FONT_FAMILY};
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.HEADING_1}px;
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.HEADING};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BLACK};
    color: ${(props): string => props.theme.kcc.colors.BLACK};
    text-transform: uppercase;
    margin: 0;

    @media screen and (max-width: ${(props): number => props.theme.kcc.screen.LG}px) {
      font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.HEADING_2}px;
    }
  }

  .add-service-case__body {
    gap: 40px;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: ${(props): string => props.theme.kcc.spacing.XXXL} 108px;

    ${maxWidth.l} {
      padding: ${(props): string => props.theme.kcc.spacing.XXXL} 36px;
    }

    ${maxWidth.m} {
      padding: 0;
      gap: 0;

      &--submitted {
        padding: 48px 23px;
      }
    }

    &--submitted {
      background-color: ${(props): string => props.theme.kcc.colors.WHITE};
    }
  }

  .add-service-case__content {
    flex: 1;
    background-color: ${(props): string => props.theme.kcc.colors.WHITE};
    padding: ${(props): number => props.theme.kcc.padding.CONTENT_HORIZONTAL}px;

    ${maxWidth.m} {
      padding: ${(props): number => props.theme.kcc.padding.CONTENT_HORIZONTAL}px 23px;
    }
  }
`;
